import baseService from "@common/externos/services/base.service";
import store from "@common/store/store";

const tbRoute = window.api_routes.smarAPD_Tributario_Domain;
const commonRoute = window.api_routes.smarAPD_Common;

let http = baseService(store, tbRoute);

const apiDef = {
  getsistemasHabilitadosPortalCidadao() {
    return http.get(
      `${commonRoute}/SistemaExterno/sistemasHabilitadosPortalCidadao/noauth`
    );
  },
  getModulosAtivosByIdSistema() {
    const alias = "Deca";
    return http.get(
      `${commonRoute}/SistemaExterno/modulosAtivosByAlias/${alias}/noauth`
    );
  },
  getParametro() {
    const funcionalidade = "Deca";
    return http.get(
      `/ParametroExterno/ParametroFuncionalidade/${funcionalidade}`
    );
  },
  validarTipoEmpresa(cpfcnpj) {
    return http.get("/DecaSolicitacaoExterno/ValidarTipoEmpresa", {
      params: {
        cpfcnpj,
      },
    });
  },
  getTipoAnexo(data) {
    return http.get("/DecaSolicitacaoExterno/TipoAnexo", {
      params: {
        cpfcnpj: data.cpfcnpj,
        tipo: data.tipo,
      },
    });
  },
  solicitacao(cpfcnpj) {
    return http.get("/DecaSolicitacaoExterno/Solicitacao", {
      params: {
        cpfcnpj: cpfcnpj,
      },
    });
  },
  solicitacaoDadosByCpfCnpj(data) {
    return http.get("/DecaSolicitacaoExterno/SolicitacaoDados", {
      params: {
        cpfCnpj: data.CpfCnpjSolicitacao,
        tipoSolicitacao: data.TipoSolicitacao,
        ccm: data.ccm,
      },
    });
  },
  save(data) {
    var formData = new FormData();

    formData.append("model", JSON.stringify(data));
    for (var key in data.DecaAnexoDto) {
      if (data.DecaAnexoDto[key].Valor) {
        formData.append(
          data.DecaAnexoDto[key].NomeArquivo,
          data.DecaAnexoDto[key].Valor
        );
      }
    }

    return http.post("/DecaSolicitacaoExterno", formData, {
      headers: {
        "Content-Type": undefined,
      },
    });
  },
  getComboGrupo() {
    return http.get("/GrupoExterno/Combobox");
  },
  update(data) {
    var formData = new FormData();

    formData.append("model", JSON.stringify(data));
    for (var key in data.DecaAnexoDto) {
      if (data.DecaAnexoDto[key].Valor) {
        formData.append(
          data.DecaAnexoDto[key].NomeArquivo,
          data.DecaAnexoDto[key].Valor
        );
      }
    }

    return http.post("/DecaSolicitacaoExterno/consultaRetificacao", formData, {
      headers: {
        "Content-Type": undefined,
      },
    });
  },
  getById(id) {
    return http.get(`/DecaSolicitacaoExterno/${id}`);
  },
  getManual() {
    return http.get(`/DecaSolicitacaoExterno/getManual`);
  },
};

export default apiDef;
